import Vue from 'vue'
import defaultState from './state'

export default {
  initStore(state) {
    Object.assign(state, defaultState)
  },
  setLandmarkList(state, landmarkList) {
    Vue.set(state, 'landmarkList', landmarkList)
  },
  setLandmarkKeyword(state, kw) {
    Vue.set(state, 'landmarkKeyword', kw)
  },
  setIsLandmarkTableLoading(state, isLoading) {
    Vue.set(state, 'isLandmarkTableLoading', isLoading)
  },
  setPaging(state, paging) {
    Vue.set(state, 'paging', paging)
  },
  setCurrentPage(state, currentPage) {
    Vue.set(state.paging, 'currentPage', currentPage)
  },
}



// WEBPACK FOOTER //
// ./src/store/landmark/mutations.js